import { Currencies } from '@/entities/curency'
import { WithdrawsModel } from '@/features/withdraws/model'
import { InfoBlockModel } from '@/shared/components/BaseBanner/BaseBanner'
import { formatCurrency } from '@/shared/lib/currency'
import { formatUSDT } from '@/shared/lib/currency/formatUSDT'
import { formatDate } from '@/shared/lib/date'
import { formatRequisite } from '@/shared/lib/requisite/formatRequisite'
import { getBankMeta } from '@/shared/utils/getBankMeta'
import { getMethodMeta } from '@/shared/utils/getMethodMeta'
import { CopyBlock } from '@/shared/components/CopyBlock/CopyBlock'
import { USER_ROLE_KEY } from '@/features/auth'
import { getStorageItem } from '@/shared/lib'
import { Roles } from '@/entities/roles'

export const getWithdrawInfoBlocks = (
  data: WithdrawsModel,
  isMobile: boolean
): {
  infoBlock1: InfoBlockModel
  infoBlock2: InfoBlockModel
  infoBlock3: InfoBlockModel
} => {
  const userRole = getStorageItem<Roles | null>(USER_ROLE_KEY, null)
  const infoBlock1: InfoBlockModel = isMobile
    ? [
        {
          label: 'Курс',
          data: formatCurrency(
            userRole === Roles.Merchant ? data.exchangeRateFromTo : data.traderExchangeRateFromTo,
            data.currencyTo
          ),
        },
        {
          label: 'Метод',
          data: getMethodMeta(data.methodToName).title,
        },
        {
          label: 'Банк',
          data: getBankMeta(data.bankToName).title,
        },
        {
          label: 'Реквизит:',
          data: (
            <CopyBlock text={data.paymentRequisitValue}>
              {formatRequisite(data.paymentRequisitValue)}
            </CopyBlock>
          ),
        },
        ...(data.recipientFullName ? [{ label: 'Получатель:', data: data.recipientFullName }] : []),
        {
          label: (
            <span className="font-medium text-main-black dark:text-white">
              {userRole === Roles.Trader ? 'Вознаграждение' : 'Комиссия'}:
            </span>
          ),
          data: (
            <div className="flex justify-between items-center">
              {userRole === Roles.Merchant && data.totalCommissionAmount && (
                <>
                  <span className="text-[18px]">
                    {formatCurrency(
                      data.exchangeRateFromTo * data.totalCommissionAmount,
                      Currencies.RUB
                    )}
                  </span>
                  <span className="text-text-secondary text-sm">
                    {formatUSDT(data.totalCommissionAmount)}
                  </span>
                </>
              )}
              {userRole === Roles.Trader &&
                formatCurrency(+data.factTraderCommissionTo, Currencies.USDT)}
            </div>
          ),
        },
      ]
    : [
        {
          label: 'Дата создания',
          data: formatDate(data.createdAt, 'long'),
        },
        {
          label: 'Дата принятия',
          data: data.confirmedByTraderAt ? formatDate(data.confirmedByTraderAt, 'long') : '—',
        },
        {
          label: userRole === Roles.Trader ? 'Вознаграждение' : 'Комиссия',
          data:
            userRole === Roles.Trader
              ? data.factTraderCommissionTo
                ? formatUSDT(+data.factTraderCommissionTo)
                : '—'
              : data.totalCommissionAmount
                ? formatUSDT(data.totalCommissionAmount)
                : '—',
        },
        {
          label: 'Курс USDT',
          data: formatCurrency(userRole === Roles.Merchant?data.exchangeRateFromTo:data.traderExchangeRateFromTo, Currencies.RUB),
        },
      ]

  const infoBlock2: InfoBlockModel = isMobile
    ? [
        {
          label: 'Дата создания',
          data: formatDate(data.createdAt, 'long'),
        },
        {
          label: 'Дата принятия',
          data: data.confirmedByTraderAt ? formatDate(data.confirmedByTraderAt, 'long') : '—',
        },
      ]
    : [
        {
          label: 'Метод',
          data: getMethodMeta(data.methodToName).title,
        },
        {
          label: 'Банк',
          data: getBankMeta(data.bankToName).title,
        },
        {
          label: 'Реквизит',
          data: (
            <CopyBlock text={data.paymentRequisitValue}>
              {formatRequisite(data.paymentRequisitValue)}
            </CopyBlock>
          ),
        },
        ...(data.recipientFullName ? [{ label: 'Получатель:', data: data.recipientFullName }] : []),
      ]

  const infoBlock3: InfoBlockModel = [
    {
      label: 'Информация о квитанции',
      data: 'Нет данных',
    },
    {
      label: 'Прикрепленные вложения',
      data: 'Вложений нет',
    },
  ]

  return { infoBlock1, infoBlock2, infoBlock3 }
}
